export default __webpack_public_path__ + "static/media/instagram.55a3cb03.svg";